
export default {
  name: 'DaSelect',
  model: {
    prop: 'selectedValue',
    event: 'input'
  },
  props: {
    selectedValue: {
      type: [String, Number],
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    inPopup: {
      type: Boolean,
      default: false
    },
    customType: {
      type: String,
      default: 'sort'
    },
    smallSize: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sortModel: {
      get () {
        return this.selectedValue
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    popperClass () {
      if (this.inPopup) {
        return this.customType === 'sort' ? 'fix-min' : ''
      } else {
        return this.customType === 'sort' ? 'fix-min z-override' : 'z-override'
      }
    }
  },
  mounted () {
    window.addEventListener('popstate', this.closeSelectDropdown)
  },
  beforeDestroy () {
    window.removeEventListener('popstate', this.closeSelectDropdown)
  },
  methods: {
    closeSelectDropdown () {
      // 리뷰 정렬 드롭다운 닫기
      if (this.$refs.elSelect) {
        this.$refs.elSelect.blur()
      }
    }
  }
}
